var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-overlay",
    {
      attrs: {
        value: _vm.showImpersonate,
        "scroll-strategy": "block",
        "z-index": "9999",
      },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.hide.apply(null, arguments)
        },
      },
    },
    [_c("select", { attrs: { id: "fromOrgSelector" } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }